var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-message"},[_c('v-alert',{attrs:{"value":_vm.hasError,"type":_vm.type,"icon":_vm.icon,"color":_vm.colors[_vm.type],"dismissible":_vm.dismissible},on:{"input":function($event){return _vm.onInput($event)}}},[_c('span',{class:`text-${_vm.type}`},[_vm._v(_vm._s(_vm.message))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }